import {Directive, Input, ElementRef, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {IconsService} from '../original-services/icons.service';
import {IconName} from '../common/types';

@Directive({
    selector: '.iconsax'
})
export class IconsaxDirective implements OnInit, OnChanges {
    @Input() iconName: IconName;
    private previousIconName: IconName;

    constructor(private el: ElementRef, private iconService: IconsService) {}

    ngOnInit() {
        if (this.iconName) {
            this.setIcon(this.iconName);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.iconName && changes.iconName.currentValue !== this.previousIconName) {
            this.setIcon(changes.iconName.currentValue);
        }
    }

    setIcon(icon: string) {
        this.iconService.loadIcon(icon).subscribe((svgContent: string) => {
            if (svgContent) {
                this.el.nativeElement.innerHTML = svgContent;
                this.previousIconName = this.iconName; // Update previous value
            }
        });
    }
}
